<template>
    <div class="flex flex-wrap py-3 border border-gray-200 rounded">
        <form class="lg:w-1/2 md:w-full" @submit.prevent="saveJabatan">
            <div class="w-full">
                <div class="flex p-8 flex-col mb-3">
                    <div class="field w-full px-3 mb-3">
                        <JetLabel
                            class="mt-3 w-full"
                            for="nama_jabatan"
                            value="Nama Jabatan"
                        />
                        <Input
                            id="nama_jabatan"
                            v-model="form.nama_jabatan"
                            type="text"
                            disabled="disabled"
                            placeholder=""
                            class="mt-1 block w-full"
                            :class="{
                                'p-invalid': form.errors.nama_jabatan,
                            }"
                        />
                        <InputError
                            :message="form.errors.nama_jabatan"
                            class="mt-2"
                        />
                    </div>
                    <div class="field w-full px-3 mb-3">
                        <JetLabel
                            class="mt-3 w-full"
                            for="bobot"
                            value="Bobot"
                        />
                        <Input
                            id="bobot"
                            v-model="form.bobot"
                            type="text"
                            disabled="disabled"
                            placeholder=""
                            class="mt-1 block w-full"
                            :class="{
                                'p-invalid': form.errors.bobot,
                            }"
                        />
                        <InputError :message="form.errors.bobot" class="mt-2" />
                    </div>
                    <div class="field w-full px-3 mb-3">
                        <JetLabel
                            class="mt-3 w-full"
                            for="tunjangan"
                            value="Tunjangan"
                        />
                        <InputNumber
                            inputId="tunjangan"
                            v-model="form.tunjangan"
                            mode="decimal"
                            :minFractionDigits="2"
                            class="mt-1 block w-full"
                            :class="{ 'p-invalid': form.errors.tunjangan }"
                        />
                        <InputError
                            :message="form.errors.tunjangan"
                            class="mt-2"
                        />
                    </div>
                    <div class="field w-full px-3 mb-3">
                        <JetLabel
                            class="mt-3 w-full"
                            for="tunjangan_khusus"
                            value="Tunj Khusus"
                        />
                        <InputNumber
                            inputId="tunjangan_khusus"
                            v-model="form.tunjangan_khusus"
                            mode="decimal"
                            :minFractionDigits="2"
                            class="mt-1 block w-full"
                            :class="{
                                'p-invalid': form.errors.tunjangan_khusus,
                            }"
                        />
                        <InputError
                            :message="form.errors.tunjangan_khusus"
                            class="mt-2"
                        />
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="flex flex-col mb-6">
                    <div class="w-full px-3 text-center">
                        <InertiaButtonEdit
                            :class="{ 'opacity-25': form.processing }"
                            label="Simpan Data"
                            v-if="form.id"
                        />
                        <InertiaButtonSave
                            :class="{ 'opacity-25': form.processing }"
                            label="Simpan Baru"
                            v-else
                        />
                    </div>
                </div>
            </div>
        </form>
        <form class="lg:w-1/2 md:w-full" @submit.prevent="saveJabatanBobot">
            <div class="w-full">
                <div class="flex p-8 flex-col mb-3">
                    <div class="field w-full px-3 mb-3">
                        <JetLabel
                            class="mt-3 w-full"
                            for="bobot_opt"
                            value="Bobot"
                        />
                        <Select
                            id="bobot_opt"
                            class="mt-1 block w-full"
                            :class="{
                                'p-invalid': form_bobot.errors.bobot,
                            }"
                            :options="$page.props.bobot_opt"
                            v-model="form_bobot.bobot"
                        />
                        <InputError
                            :message="form_bobot.errors.bobot"
                            class="mt-2"
                        />
                    </div>
                    <div class="field w-full px-3 mb-3">
                        <JetLabel
                            class="mt-3 w-full"
                            for="tunjangan"
                            value="Tunjangan"
                        />
                        <InputNumber
                            inputId="tunjangan"
                            v-model="form_bobot.tunjangan"
                            mode="decimal"
                            :minFractionDigits="2"
                            class="mt-1 block w-full"
                            :class="{
                                'p-invalid': form_bobot.errors.tunjangan,
                            }"
                        />
                        <InputError
                            :message="form_bobot.errors.tunjangan"
                            class="mt-2"
                        />
                    </div>
                    <div class="field w-full px-3 mb-3">
                        <Alert
                            :type="'warning'"
                            :header="'Hati - hati'"
                            :msg="'Perhatian proses ini akan mengubah semua tunjangan di bobot yg dipilih'"
                        />
                    </div>
                </div>
            </div>

            <div class="w-full">
                <div class="flex flex-col mb-6">
                    <div class="w-full px-3 text-center">
                        <InertiaButtonEdit
                            :class="{ 'opacity-25': form_bobot.processing }"
                            label="Simpan Data"
                        />
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import Checkbox from "primevue/checkbox";
import ButtonSave from "@/Components/ButtonSave";
import JetButton from "@/Jetstream/Button.vue";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import InertiaButtonEdit from "@/Components/InertiaButtonEdit.vue";
import InlineMessage from "primevue/inlinemessage";
import InputNumber from "primevue/inputnumber";
import Select from "@/Components/Select";
import Alert from "@/Components/Alert";

const totalRowShowed = 5;

export default defineComponent({
    props: ["selectedData"],
    components: {
        Checkbox,
        ButtonSave,
        JetButton,
        JetLabel,
        Input,
        InputError,
        InertiaButtonSave,
        InertiaButtonEdit,
        InlineMessage,
        InputNumber,
        Select,
        Alert,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                id: null,
                nama_jabatan: null,
                bobot: null,
                tunjangan: null,
                tunjangan_khusus: null,
            }),
            form_bobot: this.$inertia.form({
                _method: "POST",
                bobot: "",
                tunjangan: null,
            }),
        };
    },
    mounted() {
        //
    },
    computed: {
        //
    },
    watch: {
        // whenever question changes, this function will run
        selectedData(newSelectedData, oldSelectedData) {
            this.resetForm();
        },
    },
    methods: {
        addItem: function () {
            //
        },
        populateEdit: function (jabatan) {
            // console.log("jabatan", jabatan);
            this.form.id = jabatan.id;
            this.form.nama_jabatan = jabatan.nama_jabatan;
            this.form.bobot = jabatan.bobot;
            this.form.tunjangan = parseFloat(jabatan.tunjangan);
            this.form.tunjangan_khusus = _.isNull(jabatan.tunjangan_khusus)
                ? 0
                : parseFloat(jabatan.tunjangan_khusus);
        },
        resetForm: function (event) {
            this.form.id = null;
            this.form.nama_jabatan = null;
            this.form.bobot = null;
            this.form.tunjangan = null;
            this.form.tunjangan_khusus = null;
            // this.form.reset();
            this.form.clearErrors();

            this.form_bobot.bobot = "";
            this.form_bobot.tunjangan = null;
            // this.form_bobot.reset();
            this.form_bobot.clearErrors();
        },
        saveJabatan: function (event) {
            let self = this;
            self.form.post(route("jabatan.store"), {
                errorBag: "saveJabatan",
                preserveScroll: true,
                onSuccess: () => {
                    if (self.form.id) {
                        self.$emit("changeData", self.form);
                    } else {
                        self.$emit("loadData");
                        self.resetForm();
                    }

                    // self.$emit("loadData");
                    // self.resetForm();
                },
                onFinish: () => {
                    //
                },
            });
        },
        saveJabatanBobot: function (event) {
            let self = this;
            self.form_bobot.post(route("jabatan.storebobot"), {
                errorBag: "saveJabatanBobot",
                preserveScroll: true,
                onSuccess: () => {
                    self.$emit("loadData");
                    self.resetForm();
                },
                onFinish: () => {
                    //
                },
            });
        },
    },
});
</script>